import Image from "next/legacy/image"
import { useRouter } from "next/router"
import { Routes } from "@blitzjs/next"
import { useLegacyCurrentUser } from "app/core/hooks/useCurrentUser"
import useIsMobile from "app/core/hooks/useIsMobile"
import Logo from "public/SuperwallLogo.svg"
import { useRef, useState } from "react"
import tw from "tailwind-styled-components"
import { SFlex } from "@superwall-me/sui"

const Header = tw.div`
  flex
  justify-center
  mt-[1rem]
  p-3
  md:p-5
`

const OnboardingHeader = ({ includeMenu = false }: { includeMenu?: boolean }) => {
  // add .bg class to the body element
  if (typeof window !== "undefined") {
    // document.body.classList.add("bg")
  }

  return (
    <Header>
      <div className="w-full max-w-[1154px]">
        <SFlex justify="center">
          <div className="relative top-[3px] origin-center scale-90 md:scale-100">
            <a className="cursor-pointer" href="/">
              <Image alt={"logo"} src={Logo} />
            </a>
          </div>
        </SFlex>
      </div>
    </Header>
  )
}

export default OnboardingHeader
